module.exports = __webpack_public_path__ + "media/images/icons/wizard/progress/top-active-3ec421d6b8e8dca36ba3b4b0f58f68df.svg";